import SvgIcon from "@mui/material/SvgIcon";

export const GiftCrossIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.2 3.281c.338.583.92 1.089 1.629 1.471H1.164c-.309 0-.605.12-.823.335A1.13 1.13 0 0 0 0 5.893v3.041c0 .303.123.593.341.807.124.121.273.212.435.269v8.05c0 .302.123.591.341.805s.514.335.823.335h8.227a6.4 6.4 0 0 1-.858-.92v.16H1.94a.4.4 0 0 1-.273-.112.38.38 0 0 1-.114-.269v-7.984h7.757v.446c.346-.454.752-.86 1.205-1.206h-.429V5.513h7.951c.103 0 .202.04.274.111a.38.38 0 0 1 .114.269v3.041a.38.38 0 0 1-.2.333q.315.236.599.507l.036-.033a1.13 1.13 0 0 0 .341-.807V5.893a1.13 1.13 0 0 0-.341-.806 1.18 1.18 0 0 0-.823-.335h-4.47c.709-.382 1.29-.888 1.629-1.47a2.144 2.144 0 0 0-.24-2.575 2.23 2.23 0 0 0-1.188-.662A2.26 2.26 0 0 0 12.41.19c-1.25.508-2.318 1.984-2.713 3.595C9.302 2.173 8.235.698 6.985.19A2.27 2.27 0 0 0 5.627.046a2.24 2.24 0 0 0-1.219.696 2.143 2.143 0 0 0-.208 2.54m10.32-.376c-.65 1.12-2.518 1.916-4.197 1.84.132-1.649 1.17-3.36 2.384-3.853a1.45 1.45 0 0 1 1.682.336 1.375 1.375 0 0 1 .13 1.678m-5.21 6.41H1.163a.4.4 0 0 1-.275-.112.38.38 0 0 1-.113-.269V5.893c0-.101.04-.198.113-.269a.4.4 0 0 1 .275-.111h8.145zM5.004 1.228a1.397 1.397 0 0 0-.131 1.678c.65 1.12 2.51 1.917 4.197 1.84-.131-1.65-1.17-3.36-2.383-3.853a1.47 1.47 0 0 0-1.683.335"
        clipRule="evenodd"></path>
      <path
        fill="#fff"
        d="m16.268 12.203-4.063 4.063.33.33 4.063-4.063z"></path>
      <path fill="#fff" d="m12.535 12.204-.33.33 4.063 4.063.33-.33z"></path>
      <path
        fill="#fff"
        d="M14.401 19.765a5.365 5.365 0 0 1-1.558-10.502A5.367 5.367 0 1 1 14.4 19.765m-3.465-8.83a4.9 4.9 0 1 0 6.93 6.93 4.9 4.9 0 0 0-6.93-6.93"></path>
      <path
        stroke="#fff"
        strokeWidth="0.24"
        d="m16.268 12.203-4.063 4.063.33.33 4.063-4.063z"></path>
      <path
        stroke="#fff"
        strokeWidth="0.24"
        d="m12.535 12.204-.33.33 4.063 4.063.33-.33z"></path>
      <path
        stroke="#fff"
        strokeWidth="0.24"
        d="M14.401 19.765a5.365 5.365 0 0 1-1.558-10.502A5.367 5.367 0 1 1 14.4 19.765Zm-3.465-8.83a4.9 4.9 0 1 0 6.93 6.93 4.9 4.9 0 0 0-6.93-6.93Z"></path>
    </svg>
  </SvgIcon>
);
